<div id="product-item-list" class="px-sm-2 px-lg-0" [@blend]="animation">
  @if (products?.length < 1) {
    <div class="product-item">
      <div class="row no-gutters mb-1 grow-mobile">
        <!-- left half -->
        <div class="col-12 col-lg-6">
          <div class="image-wrapper">
            <app-skeleton-loader [loaderHeight]="'120px'" [loaderWidth]="'90%'" />
          </div>
          <div class="label-wrapper">
            <app-skeleton-loader [loaderHeight]="'4rem'" [loaderWidth]="'50%'" />
          </div>
          <div class="product-item-title d-flex align-items-center">
            <app-skeleton-loader [loaderHeight]="'1rem'" [loaderWidth]="'170px'" />
          </div>
          <div class="product-item-subtitle">
            <app-skeleton-loader [loaderHeight]="'1rem'" [loaderWidth]="'70px'" />
          </div>
          <div class="product-description">
            <app-skeleton-loader [loaderHeight]="'2rem'" />
          </div>
        </div>

        <!-- right half containing addons -->
        <div class="col-12 col-lg-6 mt-auto mt-lg-0">
          <div class="subtitle">{{ 'ALPINPRODUCT.list.additionalOffer' | alpitranslate }}</div>
          @for (i of ['9rem', '4rem', '5rem', '3rem', '4rem']; track i) {
            <div class="services pr-lg-2 pr-lg-0">
              <div class="service align-items-center d-flex">
                <div class="service-name d-flex align-items-center">
                  <app-skeleton-loader [loaderHeight]="'1rem'" [loaderWidth]="'1rem'" class="mr-1" /><span
                    ><app-skeleton-loader [loaderHeight]="'1rem'" [loaderWidth]="i"
                  /></span>
                  <!-- app icon><span-->
                </div>
                <strong class="c-pointer ml-auto flex-shrink-0"
                  ><!-- price --><app-skeleton-loader
                    [loaderHeight]="'1rem'"
                    [loaderWidth]="'3rem'" /><app-skeleton-loader
                /></strong>
                <div class="service-switch ml-2">
                  <!-- toogle switch --><app-skeleton-loader [loaderHeight]="'1rem'" [loaderWidth]="'2rem'" />
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <!-- shop price, online price and "add/remove" button -->
      <div class="row no-gutters mt-auto mt-md-1">
        <div class="col-12 col-lg-8">
          <div class="row mb-2 discount-details no-gutters">
            <div class="col col-6 text-center">
              <span data-test="productPlaceholderStorePriceLabel" class="discount-title">{{
                'ALPINPRODUCT.list.storePrice' | alpitranslate
              }}</span>
              <span
                ><app-skeleton-loader data-test="productPlaceholderStorePrice" [loaderHeight]="'1rem'"
              /></span>
            </div>
            <div class="col col-6 text-center">
              <span data-test="productPlaceholderOnlinePriceLabel" class="discount-title">{{
                'ALPINPRODUCT.list.onlinePrice' | alpitranslate
              }}</span>
              <span>
                <app-skeleton-loader data-test="productPlaceholderOnlinePrice" [loaderHeight]="'1rem'"
              /></span>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <app-skeleton-loader [loaderHeight]="'3.5rem'" />
        </div>
      </div>
    </div>
  }

  @for (product of products; track product.id) {
    <app-product-item
      [isSelected]="isSelected(product.definitionId)"
      [product]="product"
      [cart]="cart"
      [companyId]="companyId"></app-product-item>
  }
</div>
